<template>
  <div class="wechat-container">
    <div class="section-header">
      <div class="header-left">
        <h2 class="title">微信移动端与服务号绑定</h2>
        <span class="sub-title">扫码绑定采购专属服务号，随时掌握审批流转与物流履约动态</span>
      </div>
    </div>

    <div class="wechat-card-wrap">
      <div class="qr-box">
        <div class="qr-border">
          <img src="../../assets/img/wechatCode.jpg" alt="微信二维码" class="qr-img" />
        </div>
        <div class="scan-tip">
          <i class="el-icon-camera"></i>
          <span>使用微信扫一扫二维码</span>
        </div>
      </div>

      <div class="service-intro">
        <h3 class="intro-title">政企采购微信端专属服务</h3>
        <div class="intro-list">
          <div class="intro-item">
            <i class="el-icon-bell"></i>
            <div class="intro-text">
              <h4>订单状态实时推送</h4>
              <p>采购审批通过、仓库分拣打包、出库配送等节点第一时间微信模版消息触达</p>
            </div>
          </div>
          <div class="intro-item">
            <i class="el-icon-mobile-phone"></i>
            <div class="intro-text">
              <h4>移动端随行审批</h4>
              <p>主管领导无需登录电脑，手机微信端即可快速核对物料清单并一键审批</p>
            </div>
          </div>
          <div class="intro-item">
            <i class="el-icon-service"></i>
            <div class="intro-text">
              <h4>1 对 1 专属采购管家</h4>
              <p>绑定后直连您的专属商务工程师，特需寻源、急件配送与售后服务极速对接</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Wechat",
  data() {
    return {};
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.wechat-container {
  width: 100%;

  .section-header {
    padding-bottom: 16px;
    margin-bottom: 28px;
    border-bottom: 1px solid #f1f5f9;

    .header-left {
      display: flex;
      align-items: baseline;
      gap: 12px;

      .title {
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
        margin: 0;
      }

      .sub-title {
        font-size: 13px;
        color: #64748b;
      }
    }
  }

  .wechat-card-wrap {
    display: flex;
    gap: 48px;
    align-items: center;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 40px;
    max-width: 860px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.03);

    .qr-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;

      .qr-border {
        padding: 12px;
        background: #ffffff;
        border: 2px solid #e2e8f0;
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(15, 82, 186, 0.08);

        .qr-img {
          width: 200px;
          height: 200px;
          display: block;
          object-fit: contain;
        }
      }

      .scan-tip {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 14px;
        font-size: 13px;
        color: @brandPrimary;
        font-weight: 600;

        i {
          font-size: 16px;
        }
      }
    }

    .service-intro {
      flex: 1;

      .intro-title {
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
        margin: 0 0 20px;
      }

      .intro-list {
        display: flex;
        flex-direction: column;
        gap: 18px;

        .intro-item {
          display: flex;
          align-items: flex-start;
          gap: 14px;

          i {
            width: 32px;
            height: 32px;
            border-radius: 8px;
            background: #eff6ff;
            color: @brandPrimary;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            flex-shrink: 0;
            margin-top: 2px;
          }

          .intro-text {
            h4 {
              margin: 0 0 4px;
              font-size: 14px;
              font-weight: 600;
              color: #1e293b;
            }

            p {
              margin: 0;
              font-size: 12px;
              line-height: 1.6;
              color: #64748b;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/Wechat.vue